<template>
  <!-- 京开资讯 -->
  <div class="wlmq_cityHot_container">
    <div class="head">
      <div class="bodyTitle">
        <!-- <img src="../../assets/Starting/img-information/logo.png" /> -->
         <div class="pageTitle">京开资讯</div>
      </div>
    </div>
    <div class="main">
      <div class="leftMain">
        <div class="mainTitle">时间脉络</div>
        <div class="leftContent" id="demo">
          <div class="line"></div>
          <ul id="demo1">
            <li
              class="diamonds"
              v-for="(item, index) in list_data"
              :key="index"
              :class="activeIndex == index ? 'active1' : ''"
              @click="getContent(item, index)"
            >
              <div class="diamondsTitle">{{ item.title }}</div>
              <div class="pic">
                <!-- <img class="pic_img" v-if="item.source_name=='文化京开'" src="../../assets/Starting/img-information/jing.png" alt="" />
                <img class="pic_img" v-if="item.source_name=='首发新闻'" src="../../assets/Starting/img-information/shou.png" alt="" />
                 <img class="pic_img" v-if="item.source_name=='京开红窗口'" src="../../assets/Starting/img-information/logo.png" alt="" /> -->
                <div class="time">
                   <!-- <div>{{item.source_name}}</div> -->
                  <div  class="time_jing">{{ item.newsTime|formatDates }}</div>
                </div>
              </div>
            </li>
          </ul>
          <span class="icons"
            ><i
              class="iconfont icon-sancenghuan"
              v-for="(item, index) in list_data"
              :key="index"
              :class="activeIndex == index ? 'active2' : ''"
            ></i
          ></span>
          <span
            class="dashed"
            v-for="(item, index) in list_data"
            :key="index"
          ></span>
        </div>
      </div>
      <div class="rightMain">
        <div class="mainTitle">新闻详情</div>
        <!-- 点击后页面 -->
        <div class="rightContent" v-if="showBody.title">
          <div class="newTitle">{{ showBody.title }}</div>
          <div class="newSource">
            <!-- <span>{{showBody.source_name}}</span> -->
            <span>{{ showBody.newsTime | formatDate }}</span>
          </div>
          <div class="newContent">
            {{ showBody.content }}
        <div class="time_img" >
        <div class="wx_img" v-for="(item,index) in  showBody.picturesList" :key="index">
          <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imgUrl" alt="">
        </div>
        </div>
          <div v-if="showBody.MP4_URL!=null" class="video_time">
        <video v-if="showBody.MP4_URL!=null" :src="showBody.MP4_URL" controls="controls">

        </video>
       </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJinKaiNews } from "../../api/bot";
export default {
  data() {
    return {
      title: "京开资讯",
      diamonds1: [],
      diamonds2: [],
      list_data:[],
      //详情页
      showBody: "",
      show: false,
      detailInfo: "",
      activeIndex: "0",
      interval: "",
     wxPicturesList:[],
     picturesList:[]
    };
  },
  created() {
    this.load();
      setInterval(()=>{
      this.load();
    },7200000)
  },
  mounted() {},
  destroyed() {
    clearInterval(this.interval);
  },
   computed: {
    imgUrl() {
      return request.defaults.baseURL;
    },
  },
  methods: {
    load() {
      getJinKaiNews().then((res) => {
         this.list_data= res.data.data;
        this.showBody = this.list_data[0];     
        const self = this;
        if(this.list_data.length<=6){
         var time=100000000
         }else{
        var time=5000 
         }
  
       this.interval = setInterval(() => {
          if (self.list_data != []) {
            if (self.list_data.length>self.activeIndex) {
              self.activeIndex++;
              self.showBody = self.list_data[self.activeIndex];
              var demo = document.getElementById("demo");
              var demo1 = document.getElementById("demo1");
              console.log(demo.scrollTop,'我是因为');
              
              console.log(demo1.offsetHeight,'2122');
              
              if (demo.scrollTop <= demo1.offsetHeight) {
                demo.scrollTop = demo.scrollTop + 30;
              } else {
                demo.scrollTop = 0;
               self.activeIndex = 0;
              self.showBody = self.list_data[0];
              var demo = document.getElementById("demo");
              var demo1 = document.getElementById("demo1");
              }
           } else{
              self.activeIndex = 0;
              self.showBody = self.list_data[0];
              var demo = document.getElementById("demo");
              var demo1 = document.getElementById("demo1");
              demo.scrollTop = 0;
              
            }
          }
       
        }, time);
      });
    },
    getContent(item, index) {
      this.activeIndex = index;
      this.showBody = item;
     console.log('我是太阳');
     
    },
  },

};
</script>

<style scoped lang="scss">

.video_time{
  width: 100%;
  height: 10%;
  margin-top: 20px;
}
.video{
width: 70%;
 height: 200px;
}
.time_img{
  width: 100%;
  height: 5%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.wx_img{
padding: 10px;
.img_wx{
  width:40px;
  height: 40px;
}
}
.wlmq_cityHot_container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/Starting/img-information/expert_bg_img.jpg");
  background-size: 100% 100%;
.head {
    margin: 0 3vw;
    display: flex;
    align-items: center;
      height: 11%;
    justify-content: space-between;
    user-select: none;
    position: relative;
    .bodyTitle {
      height: 7.4vh;
      font-size: 0.2vw;
      font-weight: bold;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
     position: relative;
     left: -20px;
      img {
        width: 20px;
        height: 20px;
      }
      .img_monitor {
        transform: rotate(180deg);
      }
      .pageTitle {
        margin: 0 0.5em;
        white-space: nowrap;
      }
    }
  }
  .main {
    width: calc(100% - 6%);
    height: 85%;
    margin: 0.2vh 3% 3.2vh 3%;
    display: flex;
    justify-content: space-around;
    .leftMain,
    .rightMain {
      background-image: url("../../assets/Starting/img-information/media.png");
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
    }
    .mainTitle {
      width: 40%;
      height: 5%;
      margin-left: 2.5%;
      font-size: 0.34rem;
      font-weight: bold;
      color: #1db6e9;
    line-height: 1.2rem;
     
    }
    ::-webkit-scrollbar {
      width: 0; /*对垂直流动条有效*/
    }
    .active1 {
      background: linear-gradient(
        90deg,
        rgba(90, 41, 206, 1) 0%,
        rgba(153, 35, 218, 1) 100%
      ) !important;
    }
    .active2 {
      font-size: 1.05rem !important;
      left: 47.3% !important;
    }
    .active2:nth-child(1) {
      top: 6.8% !important;
    }
    .active2:nth-child(2) {  
      top: 18.8% !important;
    }
    .active2:nth-child(3) {  
      top: 31.8% !important;
    }
    .active2:nth-child(4) {  
      top: 44.8% !important;
    }
    .active2:nth-child(5) { 
      top: 59.8% !important;
    }
    .active2:nth-child(6) { 
      top: 73.8% !important;
    }
    .active2:nth-child(7) {  
      top: 88.8% !important;
    }
    .active2:nth-child(8) {  
      top: 103.8% !important;
    }
    .active2:nth-child(9) {
      top: 117.8% !important;
    }
    .active2:nth-child(10) {
      top: 130.8% !important;
    }
    .active2:nth-child(11) {
      top: 146.8% !important;
    }
    .active2:nth-child(12) {
      top: 158.8% !important;
    }
    .active2:nth-child(13) {
      top: 169.8% !important;
    }
    .active2:nth-child(14) {
      top: 180.8% !important;
    }
    .active2:nth-child(15) {
      top: 194.8% !important;
    }
    .active2:nth-child(16) {
      top: 209.8% !important;
    }
    .active2:nth-child(17) {
      top: 222.8% !important;
    }
    .active2:nth-child(18) {
      top: 236.8% !important;
    }
    .active2:nth-child(19) {
      top: 249.8% !important;
    }
    .active2:nth-child(20) {
      top: 263.8% !important;
    }
    .leftContent {
      width: 87%;
     height: 85%;
      margin: 2.5% 6.5%;
      position: relative;
      overflow-y: scroll;
      ul {
       height: 230%;
      // height: 100%;
      }
      .line {
        height: 285%;
        width: 1px;
        background: rgba(11, 246, 255, 1);
        position: absolute;
        left: 50%;
      }
      .diamonds {
        width: 41%;
        height: 25%;
        padding: 1% 2%;

        background: linear-gradient(
          90deg,
          rgba(40, 157, 204, 1) 0%,
          rgba(129, 94, 255, 1) 100%
        );
        position: absolute;
        color: #fff;
        cursor: pointer;
        .diamondsTitle { 
         width: 100%;
    font-size: 0.1rem;
    font-weight: bold;
    color: white;
   height: 4.5vh;
      overflow:hidden;
            text-overflow:ellipsis;
            display:-webkit-box;
            /*控制在3行*/
            -webkit-line-clamp:2;
            -webkit-box-orient:vertical;
        }
        .pic {
          display: flex;
          .pic_img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
          .t {
            width: 12.32%;
            height: 4.14%;
            border-radius: 50%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .time {
            margin-left: 1%;
            width: 100%;
            font-size: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          
            div {
              font-size: 0.32rem;
              width: 80%;
         
              position: relative;
             top: 0.5vh;
            }
          //   div:nth-child(2) {
          //     opacity: 0.5;
          //     position: relative;
          //     top: -20%;
          //     width: 100%;
          //     white-space:nowrap;
          //  overflow:hidden;
          //    text-overflow:ellipsis;
          //   }
          }
        }
      }

      .diamonds:hover {
        background: linear-gradient(
          90deg,
          rgba(90, 41, 206, 1) 0%,
          rgba(153, 35, 218, 1) 100%
        );
      }
      .iconfont:hover {
        font-size: 1.1rem;
        left: 47.3%;
      }
      // .iconfont:nth-child(1):hover {
      //   top: 10%;
      // }
      // .iconfont:nth-child(2):hover {
      //   top: 20%;
      // }
      // .iconfont:nth-child(3):hover {
      //   top: 31%;
      // }
      // .iconfont:nth-child(4):hover {
      //   top: 40%;
      // }
      // .iconfont:nth-child(5):hover {
      //   top: 46.8%;
      // }
      // .iconfont:nth-child(7):hover {
      //   top: 56.8%;
      // }
      // .iconfont:nth-child(8):hover {
      //   top: 66.8%;
      // }
      // .iconfont:nth-child(9):hover {
      //   top: 76.8%;
      // }
      // .iconfont:nth-child(10):hover {
      //   top: 86.8%;
      // }
      // .iconfont:nth-child(11):hover {
      //   top: 96.8%;
      // }
      // .iconfont:nth-child(12):hover {
      //   top: 106.8%;
      // }
      // .iconfont:nth-child(13):hover {
      //   top: 116.8%;
      // }
      // .iconfont:nth-child(14):hover {
      //   top: 126.8%;
      // }
      // .iconfont:nth-child(15):hover {
      //   top: 136.8%;
      // }
      // .iconfont:nth-child(16):hover {
      //   top: 146.8%;
      // }
      // .iconfont:nth-child(17):hover {
      //   top: 156.8%;
      // }
      // .iconfont:nth-child(18):hover {
      //   top: 166.8%;
      // }
      // .iconfont:nth-child(19):hover {
      //   top: 176.8%;
      // }
      // .iconfont:nth-child(20):hover {
      //   top: 186.8%;
      // }
      .iconfont {
        position: absolute;
        left: 47.55%;
        color: #0af6ff;
        font-size:0.4rem;
        z-index: 99;
        background: #03132c;
      }
      .iconfont:nth-child(1) {
        top: 7%;
      }
      .iconfont:nth-child(2) {
        top: 18%;
      }
      .iconfont:nth-child(3) {
    top: 33%;
      }
      .iconfont:nth-child(4) {
     top: 46%;
      }
      .iconfont:nth-child(5) {
   top: 62%;
      }
      .iconfont:nth-child(6) {
     top: 73%;
      }
      .iconfont:nth-child(7) {
      top: 90%;
      }
      .iconfont:nth-child(8) {
     top: 104%;
      }
      .iconfont:nth-child(9) {
       top: 118%;
      }
      .iconfont:nth-child(10) {
        top: 130%;
      }
      .iconfont:nth-child(11) {
       top: 146%;
      }
      .iconfont:nth-child(12) {
    top: 156%;
      }
      .iconfont:nth-child(13) {
       top: 169%;
      }
      .iconfont:nth-child(14) {
     top: 179%;
      }
      .iconfont:nth-child(15) {
  top: 194%;
      }
      .iconfont:nth-child(16) {
      top: 210%;
      }
      .iconfont:nth-child(17) {
      top: 224%;
      }
      .iconfont:nth-child(18) {
     top: 238%;
      }
      .iconfont:nth-child(19) {
     top: 251%;
      }
      .iconfont:nth-child(20) {
        top: 263%;
      }
      .icons {
        z-index: 10;
      }
   .dashed {
        display: inline-block;
        height: 1px;
        width: 10%;
        border-top: 2px dashed rgba(11, 246, 255, 1);
        position: absolute;
        left: 50%;
        z-index: 1;
      }
      /*.dashed:nth-child(9){ left:47%; top: 7.9vh; }
				.dashed:nth-child(10){ left:44.9%; top: 18.8vh; }
				.dashed:nth-child(11){ left:47%; top: 29.9vh; }
				.dashed:nth-child(12){ left:44.9%; top: 40.9vh; }
				.dashed:nth-child(13){ left:47%; top: 51.9vh; }
				.dashed:nth-child(14){ left:44.9%; top: 61.9vh; }*/
      .dashed:nth-child(4) {
        left: 47%;
        top: 10.9%;
      }
      .dashed:nth-child(5) {
        left: 42%;
        top: 21.9%;
      }
      .dashed:nth-child(6) {
        left: 48%;
        top: 36.9%;
      }
      .dashed:nth-child(7) {
        left: 41.9%;
       top: 49.9%;
      }
      .dashed:nth-child(8) {
        left: 48%;
       top: 65.9%;
      }
      .dashed:nth-child(9) {
        left: 41.9%;
        top: 76.9%;
      }

      .dashed:nth-child(10) {
        left: 49%;
       top: 94%
      }
      .dashed:nth-child(11) {
        left: 41.9%;
       top: 107.9%;
      }
      .dashed:nth-child(12) {
        left: 49%;
     top: 121.9%;
      }
      .dashed:nth-child(13) {
        left: 41.9%;
        top: 134.9%;
      }
      .dashed:nth-child(14) {
        left: 49%;
  top: 149.9%;
      }
      .dashed:nth-child(15) {
        left: 41.9%;
       top: 160.9%;
      }
      .dashed:nth-child(16) {
        left: 49%;
       top: 173.9%;
      }
      .dashed:nth-child(17) {
        left: 41.9%;
     top: 183.9%;
      }
      .dashed:nth-child(18) {
        left: 49%;
      top: 197.9%;
      }
      .dashed:nth-child(19) {
        left: 41.9%;
      top: 213.9%;
      }
      .dashed:nth-child(20) {
        left: 49%;
        top: 228.9%;
      }
      .dashed:nth-child(21) {
        left: 41.9%;
        top: 240.9%;
      }
      .dashed:nth-child(22) {
        left: 49.9%;
       top: 255.9%;
      }
      .dashed:nth-child(23) {
        left: 41.9%;
    top:267.9%;
      }
      .diamonds:nth-child(1) {
        top: 0;
        right: 0;
      }
      .diamonds:nth-child(2) {
        top: 11%;
        left: 0;
      }
      .diamonds:nth-child(3) {
        top: 27%;
        right: 0;
  
      }
      .diamonds:nth-child(4) {
        top: 39%;
        left: 0;
        
      }
      .diamonds:nth-child(5) {
        top: 54%;
        right: 0;
      }
      .diamonds:nth-child(6) {
        top: 66%;
        left: 0;
      }
      .diamonds:nth-child(7) {
        top: 82%;
        right: 0;
      }
      .diamonds:nth-child(8) {
        top: 94%;
        left: 0;
      }
      .diamonds:nth-child(9) {
        top: 109%;
        right: 0;
      }
      .diamonds:nth-child(10) {
        top: 121%;
        left: 0;
      }
      .diamonds:nth-child(11) {
        top: 136%;
        right: 0;
      }
      .diamonds:nth-child(12) {
        top: 148%;
        left: 0;
      }
      .diamonds:nth-child(13) {
        top: 163%;
        right: 0;
      }
      .diamonds:nth-child(14) {
     top: 175%;
        left: 0;
      }
      .diamonds:nth-child(15) {
       top: 190%;
        right: 0;
      }
      .diamonds:nth-child(16) {
      top: 203%;
        left: 0;
      }
      .diamonds:nth-child(17) {
      top: 217%;
        right: 0;
      }
      .diamonds:nth-child(18) {
        top: 231%;
        left: 0;
      }
      .diamonds:nth-child(19) {
       top:247%;
        right: 0;
      }
      .diamonds:nth-child(20) {
         top: 259%;
        left: 0;
      }
    }
    .rightContent {
      width: 90%;
      height: calc(100% - 3.4vh - 4vh);
      margin: 2vh 5%;
      overflow: hidden;
      overflow-y: auto;
      .newTitle {
        width: 100%;
        text-align: center;
        font-size: 0.3rem;
        font-weight: bold;
        color: white;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .newSource {
        width: 100%;
        height: 3%;
        font-size: 0.3rem;
        color: #0bf6ff;
        display: flex;
        margin-top: 3%;
        justify-content: space-evenly;
      }
      .newContent {
       margin-top: 10%;
        width: 100%;
        height: 59.5%;
        font-size: 0.3rem;
        color: white;
        // overflow: hidden;
        overflow-y: auto;
      }
      .newContent::-webkit-scrollbar {
        width: 5px;
        height: 3%;
      }
      ::-webkit-scrollbar-thumb {
        /*定义滑块 内阴影+圆角*/
        height: 3%;
        border-radius: 10px;
        // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #1db6e9;
      }
    }
  }

  .dialogBody {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    z-index: 100;
    .deatilDialog {
      position: absolute;
      border: 1px solid #167fff;
      color: #fff;
      background-color: #002559;
      width: 59.5%;
      height: 85%;
      left: 21%;
      top: 6.5%;
      .detailHeader {
        text-align: right;
        padding: 16px 16px;
        color: #ffffff;
        .iconfont {
          cursor: pointer;
        }
      }

      .detailBody {
        height: calc(100% - 53px);
        overflow: hidden;
        overflow-y: auto;
        .detailTitle {
          padding: 0px 86px;
          font-size: 1.7vw;
          line-height: 1.4;
          display: block;
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          text-align: center;
        }
        .detailOriginal {
          padding: 20px 35%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          color: #60d6dd;
          .original {
            display: flex;
            align-items: center;
            img {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
        .detailMain {
          padding: 0px 88px 0px 88px;
          margin-bottom: 72px;
          line-height: 2;
          font-size: 0.83vw;
        }
      }
    }
  }
  .closedialog {
    animation: action_scaleOut 0.2s ease forwards;
  }
  .opendialog {
    animation: action_translateY 0.3s ease;
  }
  @keyframes action_translateY {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  @keyframes action_scaleOut {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.2);
      opacity: 0;
    }
  }
}
</style>
